<template>
  <ImageItem
    :attachment="attachment"
    :blobUrl="previewUrl"
    :fileMetadataId="file ? null : attachment.id"
    :loadFullSize="!file"
    fancyboxData="fancybox_ai_chat"
  />
</template>

<script setup lang="ts">
/** Owns one image preview so keyed attachment removal also releases its object URL. */
import { onBeforeUnmount, onMounted, ref } from "vue"
import { useStore } from "vuex"

import ImageItem from "@/components/File/ImageItem.vue"

import { FileMetaData } from "@/models"
import { Actions } from "@/store"

const props = defineProps<{
  attachment: FileMetaData
  file?: File
}>()
const store = useStore()
const previewUrl = ref("")
let disposed = false

/** A completed private-file request must not create a preview after its image has been removed. */
onMounted(async () => {
  const blob =
    props.file ||
    (await store.dispatch(Actions.ATTACHMENT_VIEW, {
      fileMetadataId: props.attachment.id
    }))
  if (!disposed && blob instanceof Blob) {
    previewUrl.value = URL.createObjectURL(blob)
  }
})

onBeforeUnmount(() => {
  disposed = true
  if (previewUrl.value) URL.revokeObjectURL(previewUrl.value)
})
</script>
